module.exports = __webpack_public_path__ + "img/001.da22c5e7.webp";